import { CandidateProfile } from '../../../../models/candidateProfile';
import { CandidateAdditionalDetails } from '../../../../models/candidateAdditionalDetails';
import { CandidateCardQueryFilter } from 'src/app/public/app/models/candidateCardQueryFilter';
class CandidateProfileController {
    /*@ngInject*/
    constructor($rootScope, $uibModal, $timeout, companyService, userRoleService, candidateService, resumeService, modalService, sharedService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.companyService = companyService;
        this.userRoleService = userRoleService;
        this.candidateService = candidateService;
        this.resumeService = resumeService;
        this.modalService = modalService;
        this.sharedService = sharedService;
    }
    $onInit() {
        //variables
        this.candidate = new CandidateProfile();
        this.phoneInConflictToolTipMessage = "Phone Number in conflict.<br/> Update contact details.";
        this.phoneMissingToolTipMessage = "Phone Number missing.<br/> Update contact details.";
        this.emailInConflictToolTipMessage = "Email in conflict.<br/> Update contact details.";
        this.emailMissingToolTipMessage = "Email missing.<br/> Update contact details.";
        this.resumeUrl = this.resumeService.getResumeDocumentUrl(this.candidateId);
        this.resumeReportPdfUrl = this.resumeService.getResumeDownloadPdfUrl(this.candidateId);
        this.resumeDownloadPdfUrl = this.resumeService.getResumeDownloadPdfUrl(this.candidateId);
        //flags
        this.loadingFlag = true;
        this.showProfileUrlFlag = false;
        this.showSalary = false;
        this.isCandidateProfileContactDetailsMissing = false;
        this.isCandidateProfileContactAdditionalDetailsMissing = false;
        this.isPdfGeneratedBySystem = false;
        this._getCandidateProfile();
    }
    _getCandidateProfile() {
        this.loadingFlag = true;
        this.showProfileUrlFlag = false;
        this.candidateService.getCandidateProfile(this.candidateId, false, (data) => {
            _.merge(this.candidate, data);
            if (data.candidateAdditionalDetails) {
                this.candidate.candidateAdditionalDetails.workLocations = _.cloneDeep(data.candidateAdditionalDetails.workLocations);
            }
            this.candidate = this._massageCandidateData(this.candidate);
            this.candidate.profileUrlText = '';
            if (!_.isNull(this.candidate.profileUrl)) {
                this.showProfileUrlFlag = true;
                if (this.candidate.profileType != 'Other') {
                    this.candidate.profileUrlText = "View Candidate's " + this.candidate.profileType + " Profile";
                }
                else {
                    this.candidate.profileUrlText = "View Candidate's Profile";
                }
            }
            if (this.candidate.candidateCompanyId === this.$rootScope.userDetails.company.companyId && !this.userRoleService.isLoggedInUserEmployee()) {
                this.showSalary = true;
            }
            this._checkIfContactDetailsMissing();
            if (this.candidate.resume) {
                this.isPdfGeneratedBySystem = this.candidate.resume.isPdfGeneratedBySystem;
            }
            // Call candidate card API to get total experience.
            let filterParams = new CandidateCardQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
            this.candidateService.getCandidateCard(this.candidateId, this.$rootScope.userDetails.id, filterParams, (data) => {
                this.candidate.totalExperience = data.totalExperience;
                this.loadingFlag = false;
            }, (error) => {
                this.loadingFlag = false;
            });
        }, (error) => {
            console.log('candidate get error - ', error);
            // do nothing.
        });
    }
    _massageCandidateData(candidate) {
        candidate.name = candidate.firstName + ' ' + candidate.lastName;
        if (_.isNull(candidate.title)) {
            candidate.title = '-';
        }
        if (_.isNull(candidate.email)) {
            candidate.email = '-';
        }
        if (_.isNull(candidate.mobilePhone)) {
            candidate.mobilePhone = '-';
        }
        if (_.isNull(candidate.candidateAdditionalDetails)) {
            candidate.candidateAdditionalDetails = new CandidateAdditionalDetails();
        }
        candidate.candidateAdditionalDetails.candidateId = this.candidateId;
        candidate.displayAddress1 = '';
        candidate.displayAddress2 = '';
        if (_.isNull(candidate.address)) {
            candidate.displayAddress1 = '-';
            candidate.displayAddress2 = '-';
        }
        else {
            candidate.displayAddress1 += _.isNull(candidate.address.address1) ? '' : candidate.address.address1;
            candidate.displayAddress1 += _.isNull(candidate.address.address2) ? '' : ', ' + candidate.address.address2;
            candidate.displayAddress2 += _.isNull(candidate.address.city) ? '' : candidate.address.city;
            candidate.displayAddress2 += _.isNull(candidate.address.county) ? '' : ', ' + candidate.address.county;
            candidate.displayAddress2 += _.isNull(candidate.address.municipality) ? '' : ', ' + candidate.address.municipality;
            candidate.displayAddress2 += _.isNull(candidate.address.state) ? '' : ', ' + candidate.address.state;
            candidate.displayAddress2 += _.isNull(candidate.address.region) ? '' : ', ' + candidate.address.region;
            candidate.displayAddress2 += _.isNull(candidate.address.county) ? '' : ', ' + candidate.address.country;
            candidate.displayAddress2 += _.isNull(candidate.address.zipcode) ? '' : ', ' + candidate.address.zipcode;
        }
        if (candidate.mobilePhoneCountryCodePresent) {
            var phoneNumberObject = libphonenumber.parse(candidate.mobilePhone.toString());
            if (phoneNumberObject.phone !== undefined) {
                candidate.mobilePhone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
            }
        }
        angular.forEach(candidate.educations, (education, key) => {
            if (_.isNull(education.instituteName) || education.instituteName === "") {
                education.instituteName = "'Unknown'";
            }
            if (education.startDate) {
                education.startDate.formattedMonth = this._getMonthByNumber(education.startDate.monthOfYear);
            }
            if (education.endDate) {
                education.endDate.formattedMonth = this._getMonthByNumber(education.endDate.monthOfYear);
            }
            this._setDateRange(education);
        });
        angular.forEach(candidate.experiences, (experience, key) => {
            if (_.isNull(experience.employerName) || experience.employerName === "") {
                experience.employerName = "'Unknown'";
            }
            if (experience.startDate) {
                experience.startDate.formattedMonth = this._getMonthByNumber(experience.startDate.monthOfYear);
            }
            if (experience.endDate) {
                experience.endDate.formattedMonth = this._getMonthByNumber(experience.endDate.monthOfYear);
            }
            this._setDateRange(experience);
        });
        // if(_.isNull(candidate.educations)){
        //     candidate.educations = [];
        // }
        // if(_.isNull(candidate.experiences)){
        //     candidate.experiences = [];
        // }
        // if(_.isNull(candidate.technicalSkills)){
        //     candidate.technicalSkills = [];
        // }
        // if(_.isNull(candidate.softSkills)){
        //     candidate.softSkills = [];
        // }
        // if(_.isNull(candidate.certifications)){
        //     candidate.certifications = [];
        // }
        // if(_.isNull(candidate.others)){
        //     candidate.others = [];
        // }
        // if(_.isNull(candidate.compensations)){
        //     candidate.compensations = [];
        // }
        candidate.isResumeFilePdf = false;
        if (candidate.resume && candidate.resume.fileName) {
            candidate.isResumeFilePdf = (candidate.resume.fileName.slice(-4)) === '.pdf' ? true : false;
        }
        return candidate;
    }
    _setDateRange(experience) {
        experience.dateRange = "(";
        if (experience.startDate) {
            experience.dateRange = `${experience.dateRange}${experience.startDate.formattedMonth}, ${experience.startDate.year} -`;
        }
        if (experience.endDate) {
            experience.dateRange = `${experience.dateRange} ${experience.endDate.formattedMonth}, ${experience.endDate.year}`;
        }
        else {
            experience.dateRange = `${experience.dateRange}Current`;
        }
        experience.dateRange = `${experience.dateRange})`;
        if (!experience.startDate && !experience.endDate) {
            experience.dateRange = "";
        }
    }
    _getMonthByNumber(monthNumber) {
        switch (monthNumber) {
            case 1: return "Jan";
            case 2: return "Feb";
            case 3: return "Mar";
            case 4: return "Apr";
            case 5: return "May";
            case 6: return "Jun";
            case 7: return "Jul";
            case 8: return "Aug";
            case 9: return "Sep";
            case 10: return "Oct";
            case 11: return "Nov";
            case 12: return "Dec";
        }
    }
    _checkIfContactDetailsMissing() {
        this.isCandidateProfileContactDetailsMissing = !this.sharedService.isContactDetailsAvailable(this.candidate, 'candidateCard');
        this.isCandidateProfileContactAdditionalDetailsMissing = !this.sharedService.isCandidateAdditionalDetailsAvailable(this.candidate);
        if (this.isCandidateProfileContactDetailsMissing || this.isCandidateProfileContactAdditionalDetailsMissing) {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback({ result: true });
            }
        }
        else {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback({ result: false });
            }
        }
    }
    saveCallback() {
        this._getCandidateProfile();
    }
    launchActionsModal(type) {
        var actionType = '';
        var actionLabel = '';
        switch (type) {
            case 'updateContact':
                actionType = 'updateContact';
                actionLabel = 'Update Candidate Contact Details';
                break;
            default:
                break;
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(() => {
            let candidateProfileActionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: 'four-dot-five-modal-medium',
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: () => {
                        return actionType;
                    },
                    actionLabel: () => {
                        return actionLabel;
                    },
                    candidateId: () => {
                        return this.candidateId;
                    },
                    reloadCandidateProfile: () => {
                        return this.init;
                    }
                }
            });
            candidateProfileActionsModal.result.then((callbackObject) => {
                if (callbackObject.callbackType == 'refresh') {
                    this._getCandidateProfile();
                }
            }, (dismiss) => {
                //do nothing;
            });
        }, 300);
    }
    editTechnicalSkills() {
        this.isEditTechnicalSkills = !this.isEditTechnicalSkills;
    }
    editSoftSkills() {
        this.isEditSoftSkills = !this.isEditSoftSkills;
    }
    _hasCandidateProfileChanged() {
        return !angular.equals(this.candidate, this.candidateCopy);
    }
}
CandidateProfileController.$inject = ['$rootScope', '$uibModal', '$timeout', 'companyService', 'userRoleService', 'candidateService', 'resumeService', 'modalService', 'sharedService'];
// import * as TEMPLATE from './candidate-profile.html';
import * as TEMPLATE from 'raw-loader!./candidate-profile.html';
export const CandidateProfileComponent = {
    selector: 'candidateProfile',
    component: {
        bindings: {
            candidateId: '@',
            jobMatchId: '@',
            context: '@',
            documentInfo: '<',
            hideResume: '<',
            candidateContactDetailsMissingCallback: '&'
        },
        controller: CandidateProfileController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidate-profile.html'
    }
};
//# sourceMappingURL=candidate-profile.component.js.map